import React, { useContext } from 'react'
import CurrencyFormat from 'react-currency-format'
import { I18nContext } from 'i18n'
import {
  List,
  ProgramName,
  Organization,
  Description,
  Criteria,
  Elegibility,
  NotMember,
} from './style'
import Markdown from 'react-markdown'
import { DATE_MOMENT_FORMAT } from 'utils/constants'
import moment from 'moment'
import styled from 'styled-components'
import nspaIcon from 'images/nspa-icon.png'

const ProgramDetail = ({
  program: {
    programName,
    programOrganization: { organizationName },
    blurb,
    eligibilityCriteriaDescription,
    scholarshipMaximumAward,
    isNeedBased,
    isMeritBased,
    isContest,
    openDate,
    closeDate,
    applicationURL,
    programURL,
    applicationType,
    numberOfScholarshipsAwarded,
    awardDuration,
  },
  isMember,
}) => {
  const { translate } = useContext(I18nContext)
  const renderDetail = (criteriaDesc) => (
    <List>
      <Markdown source={criteriaDesc} />
    </List>
  )

  const renderOrgPath = (organizationName) => {
    return (
      <Organization
        href={`/member-detail-search?name=${encodeURIComponent(
          organizationName
        )}`}
      >
        {organizationName}
      </Organization>
    )
  }

  return (
    <>
      <ProgramName>{programName}</ProgramName>
      {isMember ? (
        <>
          <NspaIcon src={nspaIcon} alt="" />
          {renderOrgPath(organizationName)}
        </>
      ) : (
        <>
          {renderOrgPath(organizationName)}
          <span className="ml-2">{translate('not_a_member')}</span>
        </>
      )}
      <Description>
        <Markdown source={blurb || ''} />
      </Description>
      <Criteria>
        <div>{translate('program_criteria_desc')}</div>
        {eligibilityCriteriaDescription && (
          <Elegibility>
            {renderDetail(eligibilityCriteriaDescription)}
          </Elegibility>
        )}
      </Criteria>
      <Description>
        <div className="mb-3">{translate('program_award_info')}</div>
        {/* awardDuration */}
        <div>
          <span>{translate('program_award_type')}:</span>{' '}
          {awardDuration?.awardDurationType || 'Not Available'}
        </div>
        <div>
          <span>{translate('program_number_awards')}:</span>{' '}
          {numberOfScholarshipsAwarded || 'Not Available'}
        </div>
        <div>
          <span>{translate('program_total_award')}:</span>{' '}
          {scholarshipMaximumAward && scholarshipMaximumAward > 0 ? (
            <CurrencyFormat
              value={scholarshipMaximumAward}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
            />
          ) : (
            'Not Available'
          )}
        </div>
        <div>
          <span>{translate('program_need_based')}:</span>{' '}
          {isNeedBased ? 'Yes' : 'No'}
        </div>
        <div>
          <span>{translate('program_merit_based')}:</span>{' '}
          {isMeritBased ? 'Yes' : 'No'}
        </div>
        {isContest && (
          <div>
            <span>{translate('program_contest')}:</span>{' '}
            {isContest ? 'Yes' : 'No'}
          </div>
        )}
        <div>
          <span>{translate('program_url')}:</span>{' '}
          <a href={programURL} target="_blank" rel="noopener noreferrer">
            {programURL}
          </a>
        </div>
      </Description>
      <Description>
        <div className="mb-3">{translate('program_application_info')}</div>
        <div>
          <span>{translate('applicationType')}:</span> {applicationType}
        </div>
        {openDate && (
          <div>
            <span>{translate('openDate')}:</span>{' '}
            {moment(openDate).format(DATE_MOMENT_FORMAT)}
          </div>
        )}
        {closeDate && (
          <div>
            <span>{translate('program_application_deadline')}:</span>{' '}
            {moment(closeDate).format(DATE_MOMENT_FORMAT)}
          </div>
        )}

        <div>
          <span>{translate('upload_application_url')}:</span>{' '}
          <a href={applicationURL} target="_blank" rel="noopener noreferrer">
            {applicationURL}
          </a>
        </div>
      </Description>
    </>
  )
}

const NspaIcon = styled.img`
  width: 24px;
  margin-right: 0.5rem;
`

export default ProgramDetail
